module.exports = __webpack_public_path__ + "static/oss-logo-lockup-social-d0af403cc4e0189bce89b52a684e93eb.png";